module.exports = __webpack_public_path__ + "img/telehealth_office-visit.c6ed2264.svg";